import {
  primaryColors,
  transparentColors
} from '@assets/styles/helpers/colors.styles'
import { floatingSurface } from '@/shared/styles/floatingSurface.styles'

export const imageUploadButtonStyles = {
  outline: 'none !important',
  background: transparentColors.whiteShade2,
  padding: '1rem 1rem 0.5rem 1rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  borderRadius: '0.5rem'
}

export const badgeStyles = {
  '.MuiBadge-badge': {
    color: primaryColors.black,
    background: primaryColors.white
  }
}

export const tooltipStyles = {
  '&.MuiTooltip-tooltip': {
    ...floatingSurface,
    zIndex: '5 !important',
    padding: '0.125rem 0.5rem',
    width: 'fit-content',
    margin: '0.25rem 0 0 0 !important'
  }
}

export const popperStyles = {
  zIndex: 1
}
